<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <CRow class="justify-content-center">
                      <CIcon src="img/Jeeto_logo_png_1.png" height="100" alt="Logo" />
                  </CRow>
                  <h5 class="text-center">Admin Login</h5>
                  <CInput placeholder="Email" v-model="email">
                    <template #prepend-content>
                      <CIcon name="cil-user" />
                    </template>
                  </CInput>
                  <CInput placeholder="Password" type="password" v-model="password">
                    <template #prepend-content>
                      <CIcon name="cil-lock-locked" />
                    </template>
                  </CInput>
                  <CRow>
                    <span class="text-danger"> {{ password_warning }} </span>
                    <CCol col="6" class="text-left">
                      <CButton color="primary" @click="login" class="px-4">Login</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                     <!-- <CButton color="link" class="px-0">Forgot password?</CButton>-->
                      <CButton color="link" class="d-lg-none">Register now!</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <!--<CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>Sign up</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                <CButton color="light" variant="outline" size="lg">Register Now!</CButton>
              </CCardBody>
            </CCard>-->
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      email: '',
      password: '',
      password_warning: ''
    }
  },
  methods: {
    login() {
      this.$store.dispatch('auth/login', {email: this.email, password: this.password})
              .then((response) => {
                console.log('Login Success .... ', response);
                this.$router.push({path: '/'});
              }).catch((error) => {
        console.log('Login Error ... ', error.response);
        this.password_warning = error.response.data.message ?  error.response.data.message : 'Credential unmatched'
      })
    }
  }
};
</script>
